module.exports = __webpack_public_path__ + "img/button-p2=hover.23d26b53.png";